__turbopack_context__.v({
  "callToActionContainer": "StackedCards-module-scss-module__Ai9BsG__callToActionContainer",
  "callToActionDescription": "StackedCards-module-scss-module__Ai9BsG__callToActionDescription",
  "cardToolTip": "StackedCards-module-scss-module__Ai9BsG__cardToolTip",
  "compact": "StackedCards-module-scss-module__Ai9BsG__compact",
  "iconWrap": "StackedCards-module-scss-module__Ai9BsG__iconWrap",
  "imageWrapper": "StackedCards-module-scss-module__Ai9BsG__imageWrapper",
  "infoCircleIcon": "StackedCards-module-scss-module__Ai9BsG__infoCircleIcon",
  "title": "StackedCards-module-scss-module__Ai9BsG__title",
  "viewMore": "StackedCards-module-scss-module__Ai9BsG__viewMore",
  "wrapper": "StackedCards-module-scss-module__Ai9BsG__wrapper",
});
